export const text = {
    // TODO: localize
    toNavigate: `to navigate`,
    toSelect: `to select`,
    toDismiss: `to dismiss`,
};
